import React from "react";
import { Heart, Award, Users, Shield } from "lucide-react";

const AboutPage: React.FC = () => {
  const stats = [
    { number: "25+", label: "Years of Experience" },
    { number: "4", label: "Premier Locations" },
    { number: "500+", label: "Happy Residents" },
    { number: "24/7", label: "Care Available" },
  ];

  const values = [
    {
      icon: Heart,
      title: "Compassion",
      description:
        "Personalized, one-on-one care tailored to each resident’s unique needs",
    },
    {
      icon: Shield,
      title: "Safety & Security",
      description:
        "A resident-centered approach that honors dignity, independence, and joy.",
    },
    {
      icon: Award,
      title: "Excellence",
      description:
        "Strong family involvement and open, transparent communication.",
    },
    {
      icon: Users,
      title: "Community",
      description:
        "A living environment intentionally designed for safety, comfort, and community.",
    },
    {
      icon: Heart,
      title: "Nutrition",
      description:
        "Nutritious, wholesome meals created in consultation with licensed nutritionists.",
    },
    {
      icon: Heart,
      title: "Compassion",
      description:
        "Policies and practices that meet—and consistently exceed—state standards.",
    },
  ];

  const excellence = [
    {
      icon: Heart,
      title: "Compassion",
      description:
        "Advanced expertise in Dementia and Alzheimer’s care, fall prevention, infection control, and medication management.",
    },
    {
      icon: Shield,
      title: "Safety & Security",
      description:
        "Collaborative relationships with primary care physicians, home health, and hospice partners to ensure continuity of care.",
    },
    {
      icon: Award,
      title: "Excellence",
      description:
        "Ongoing staff training and development that builds skill, consistency, and compassion in every caregiver.",
    },
  ];

  // const team = [
  //   {
  //     name: "Dr. Sarah Mitchell",
  //     title: "Chief Medical Officer",
  //     image:
  //       "https://images.pexels.com/photos/5452201/pexels-photo-5452201.jpeg",
  //     bio: "Board-certified geriatrician with over 20 years of experience in senior care and memory disorders.",
  //   },
  //   {
  //     name: "Michael Johnson",
  //     title: "Director of Operations",
  //     image:
  //       "https://images.pexels.com/photos/5452202/pexels-photo-5452202.jpeg",
  //     bio: "Healthcare administration expert ensuring smooth operations and exceptional resident experiences.",
  //   },
  //   {
  //     name: "Lisa Rodriguez",
  //     title: "Director of Nursing",
  //     image:
  //       "https://images.pexels.com/photos/5452203/pexels-photo-5452203.jpeg",
  //     bio: "Registered nurse with specialized training in geriatric care and staff development.",
  //   },
  // ];

  // const accreditations = [
  //   "Joint Commission Accredited",
  //   "Medicare & Medicaid Certified",
  //   "State Licensed Facility",
  //   "Better Business Bureau A+ Rating",
  //   "AHCA Quality Award Winner",
  //   "CMS 5-Star Rating",
  // ];

  return (
    <div className="pt-8" id="about">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-green-50 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              About Almond Tree
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              At Almond Tree Senior Care, we provide a comforting and nurturing
              home where each resident is cared for with dignity, purpose, and
              genuine compassion. With over 25 years of experience, we create a
              safe and uplifting environment that truly feels like the next best
              place to home.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-green mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Our Mission
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                At Almond Tree Senior Care, our mission is to create a warm,
                safe, and purposeful home where every resident can thrive.
                Guided by decades of experience in senior care healthcare, Sonia
                Idnani leads our community with compassion, integrity, and a
                commitment to excellence in assisted living.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg"
                alt="Senior care team"
                className="rounded-lg shadow-lg w-full h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Core Values
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              These principles guide everything we do and shape the culture of
              care across all our facilities.
            </p>
          </div>
          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center group">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6 group-hover:bg-green-200 transition-colors duration-300">
                  <value.icon className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div> */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((service, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <service.icon className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  {/* <h3 className="text-lg font-semibold text-gray-900 mb-2"> */}
                  {/* {service.title} */}
                  {/* </h3> */}
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Excellence Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Excellence
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              These principles guide everything we do and shape the culture of
              care across all our facilities.
            </p>
          </div>
          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center group">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6 group-hover:bg-green-200 transition-colors duration-300">
                  <value.icon className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div> */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {excellence.map((service, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <service.icon className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  {/* <h3 className="text-lg font-semibold text-gray-900 mb-2"> */}
                  {/* {service.title} */}
                  {/* </h3> */}
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      {/* <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Leadership Team
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Our experienced leadership team brings together decades of
              expertise in healthcare, operations, and senior services.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-primary-green font-medium mb-3">
                    {member.title}
                  </p>
                  <p className="text-gray-600 leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Accreditations */}
      {/* <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Accreditations & Awards
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Our commitment to excellence is recognized by leading healthcare
              organizations and agencies.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {accreditations.map((accreditation, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 p-4 bg-green-50 rounded-lg"
              >
                <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0" />
                <span className="text-gray-900 font-medium">
                  {accreditation}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* History Section */}
      {/* <section className="py-20 bg-primary-green text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8">Our Story</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
              <div className="bg-white bg-opacity-10 rounded-lg p-6">
                <div className="text-3xl font-bold mb-2">1998</div>
                <h3 className="text-xl font-semibold mb-3">The Beginning</h3>
                <p className="opacity-90">
                  Founded with a vision to revolutionize senior care, starting
                  with our first facility.
                </p>
              </div>
              <div className="bg-white bg-opacity-10 rounded-lg p-6">
                <div className="text-3xl font-bold mb-2">2010</div>
                <h3 className="text-xl font-semibold mb-3">Expansion</h3>
                <p className="opacity-90">
                  Opened three additional facilities to serve more communities
                  with specialized care.
                </p>
              </div>
              <div className="bg-white bg-opacity-10 rounded-lg p-6">
                <div className="text-3xl font-bold mb-2">2025</div>
                <h3 className="text-xl font-semibold mb-3">Excellence</h3>
                <p className="opacity-90">
                  Continuing to set the standard for assisted living care with
                  innovative services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPage;
